import { useEffect, useSyncExternalStore } from 'react';

/**
 * Registre des exports de la PAGE COURANTE — miroir du pattern
 * printReportsRegistry, mais vivant : chaque page déclare (au montage) les
 * formats qu'elle sait produire ; le bouton export du coin bas-gauche
 * (Sidebar) les liste dans son popover et déclenche le `run` choisi.
 * Page sans export → registre vide → bouton atténué.
 *
 * Option : { id: 'excel' | 'pdf' | …, label: string, run: () => void }
 */
let current = [];
const subs = new Set();

function notify() { subs.forEach((f) => f()); }

export function setPageExports(list) {
  current = Array.isArray(list) ? list : [];
  notify();
}

function subscribe(f) { subs.add(f); return () => subs.delete(f); }
function getSnapshot() { return current; }

/** Côté consommateur (bouton du coin) : liste réactive des options. */
export function usePageExports() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

/** Côté page : déclare ses exports tant qu'elle est montée. Une sous-page
    EMBARQUÉE dans un hub passe `enabled = false` : c'est le hub qui déclare,
    et le démontage de l'onglet n'efface pas ce que le hub a posé (2026-09-12). */
export function useRegisterPageExports(options, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    setPageExports(options);
    return () => setPageExports([]);
  }, [options, enabled]);
}
